import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    makeStyles,
} from "@material-ui/core";
import React, { useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import formStepSequence from "../../form/Form098/Form098StepSequence";
import { setCurrentStep, setStepSequence } from "../../redux/action";
import { getForm, getStatus, getStepSequence } from "../../redux/selector";

const style = {
    height: "20px",
    width: "140px",
    background: "#a74128",
    color: "#fff",
};
const style_hover = {
    height: "20px",
    width: "140px",
    background: "#300101",
    color: "#fff",
};

const editBtnStyle = makeStyles(() => ({
    root: {
        "@media (max-width: 500px)": {
            height: "auto !important",
            maxWidth: "fit-content !important",
        },
    },
}));
function EditButton({ redirectTo, buttonOn = true, cRef }) {
    const { formId } = useSelector(getForm());
    const [openPopup, setOpenPopup] = useState(false);
    const [hover, setHover] = useState(false);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const formStatus = useSelector(getStatus());
    const currentStepSequence = useSelector(getStepSequence());

    const handleRedirect = () => {
        if (formId == "Form098" && (formStatus == 1 || formStatus == 2)) {
            // dispatch(stepSequenceNext(redirectTo, currentStepSequence));
            dispatch(setStepSequence(formStepSequence.applicantReturn));
        }

        dispatch(setCurrentStep(redirectTo));
    };
    const handleClose = () => {
        setOpenPopup(false);
    };

    const handleMouseEnter = () => {
        setHover(true);
    };

    const handleMouseLeave = () => {
        setHover(false);
    };
    useImperativeHandle(cRef, () => ({
        setOpenPopup: (newVal) => {
            setOpenPopup(true);
        },
    }));

    const editBtnClasses = editBtnStyle();
    return (
        <>
            {buttonOn && (
                <Button
                    classes={{ root: editBtnClasses.root }}
                    variant="contained"
                    onClick={() => {
                        setOpenPopup(true);
                    }}
                    size="small"
                    component="span"
                    style={hover ? style_hover : style}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    {t("common.confirmation.editThisSection")}
                </Button>
            )}
            <Dialog
                open={openPopup}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("common.confirmation.popupTitle")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("common.confirmation.popupContent")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{t("common.cancel")}</Button>
                    <Button onClick={handleRedirect}>
                        {t("common.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default EditButton;
